/**
 * `MediaAttachments` — render a message's attachments in the widget: images inline (tap → full
 * size), other files as a download chip. Stored URL is API-relative, prefixed with the API base.
 */

import type { MessageMedia } from '@flozic/shared/types';
import { widgetEnv } from '../config/env';

function fullUrl(url: string): string {
  return /^https?:\/\//.test(url) ? url : `${widgetEnv.apiBaseUrl}${url}`;
}

export function MediaAttachments({ media }: { media: MessageMedia[] }) {
  if (!media?.length) return null;
  return (
    <div className="mt-1.5 flex flex-col gap-1.5">
      {media.map((m, i) => {
        const href = fullUrl(m.url);
        if (m.contentType === 'image') {
          return (
            <a key={i} href={href} target="_blank" rel="noreferrer noopener" className="block">
              <img
                src={href}
                alt={m.filename || 'attachment'}
                loading="lazy"
                referrerPolicy="no-referrer"
                className="max-h-56 max-w-full rounded-lc border border-black/10 object-contain"
              />
            </a>
          );
        }
        return (
          <a
            key={i}
            href={href}
            target="_blank"
            rel="noreferrer noopener"
            className="flex items-center gap-2 rounded-lc border border-black/10 px-2 py-1.5 text-xs hover:bg-black/5"
          >
            <span aria-hidden>📎</span>
            <span className="truncate">{m.filename || 'Attachment'}</span>
          </a>
        );
      })}
    </div>
  );
}

export default MediaAttachments;
